import React from 'react';

import { ShortStudent } from '../../services/students/types';
import StudentStateChip from '../StudentStateChip';
import UserListItem from '../UserListItem';

interface StudentListItemProps {
  student: ShortStudent,
  showState?: boolean,
}

const StudentListItem = ({
  student,
  showState = true,
  ...props
}: StudentListItemProps) => (
  <UserListItem
    {...props}
    key={student.id}
    firstName={student.firstName}
    lastName={student.lastName}
    label={`${student.name} (${student.gradYear})`}
    profileIconColor={student.profileIcon?.color}
    profileIconImage={student.profileIcon?.image}
    displayedProprties={[student.school]}
    renderStateChip={showState ? () => <StudentStateChip state={student.state} /> : undefined}
  />
);
export default StudentListItem;
